import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=caf96d36"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"
import style0 from "./Page.vue?vue&type=style&index=0&id=caf96d36&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
